<template>
  <div class="flex-grow-1">
    <v-menu offset-y ref="menu">
      <template #activator="{ on }">
        <div v-on="on">
          <v-text-field
            light
            background-color="white"
            color="grey"
            solo
            flat
            v-model="value"
            prepend-inner-icon="mdi-magnify"
            :label="$t('common.search_pef')"
            hide-details
            :loading="loading"
            autocomplete="off"
          />
        </div>
      </template>

      <v-list v-if="showAlert">
        <v-list-item
          >{{ $t("Common.noSearchResults") }} "{{ value }}"</v-list-item
        >
      </v-list>

      <div v-else-if="showResults">
        <v-list v-for="(group, index) in groups" :key="group.key" subheader>
          <v-subheader>
            {{ group.name }}
          </v-subheader>
          <span v-if="group.items.length > 0">
            <v-list-item
              v-for="item in group.items"
              :key="`${group.key}-${item.id}`"
              @click="redirect(group, item.id)"
            >
              {{ item.first_name }} {{ item.last_name }} ({{
                $t("common.role." + item.role.toLowerCase())
              }})
            </v-list-item>
          </span>
          <span v-else>
            <v-list-item>
              {{ $t("common.no_results") }}
            </v-list-item>
          </span>

          <v-divider v-if="index < groups.length - 1" />
        </v-list>
      </div>
    </v-menu>
  </div>
</template>

<script>
import debounce from "lodash/debounce"

export default {
  name: "searchAppBar",
  data: () => ({
    searchField: "",
    loading: false,
  }),
  computed: {
    isSearchPage() {
      return this.$route.path === "/search"
    },

    showAlert() {
      return false
    },
    items() {
      return this.$store.state.search.result
    },

    showResults() {
      return !this.isSearchPage && !this.loading
    },

    groups() {
      return Object.keys(this.items).map((group) => ({
        key: group,
        name: this.groupName(group),
        items: this.items[group],
      }))
    },

    value: {
      get() {
        return this.searchField
      },
      set(value) {
        if (typeof value === "string" && value !== this.searchField) {
          //this.$store.commit('search/SET_VALUE', value)
          this.searchField = value
          this.search(value)
        }
      },
    },
  },

  methods: {
    groupName(group) {
      const name =
        {
          users: "user",
        }[group] || group

      return this.$tc(`common.${name}`, 2)
    },

    search: debounce(function (value) {
      this.loading = true
      this.$store.commit("search/SEARCH", [])
      let self = this
      this.$store
        .dispatch("search/SEARCH", { keyword: value, role: "pef" })
        .then(() => {
          this.$refs.menu.mouseEnterHandler()
        })
        .finally(() => {
          self.loading = false
        })
    }, 1000),

    url(group, id) {
      return `/${group.key}/${id}`
    },

    redirect(group, id) {
      this.$router.replace({
        path: this.url(group, id),
      })
    },
  },
}
</script>
